import api from '@/services/api'
import type {
  AlertsFilter,
  SwapAlertsFilter,
  SpotAlertsResponse,
  SwapAlertsResponse,
  SortOrder,
  SwapAlertSortingKey,
  DexAlertsFilter,
  DexAlertSortingKey,
  DexAlertsResponse,
  DexDexAlertsFilter,
  DexDexAlertSortingKey,
  DexDexAlertsResponse,
  DexDexCrosschainAlertsFilter,
  DexDexCrosschainAlertSortingKey,
  DexDexCrosschainAlertsResponse,
} from './types'

export const AlertsV2Service = {
  /* spot */
  fetchSpotPro(page: number, filter: AlertsFilter) {
    return api.post<SpotAlertsResponse>(`/v2/alerts/spot?page=${page}`, filter)
  },
  fetchSpotDemo(page: number, filter: AlertsFilter) {
    return api.post<SpotAlertsResponse>(`/v2/alerts/spot/demo?page=${page}`, filter)
  },
  /* swap/futures */
  fetchSwap(
    page: number,
    filter: SwapAlertsFilter,
    sortField: SwapAlertSortingKey,
    sortOrder: SortOrder,
  ) {
    // Устанавливаем стандартное значение
    if (filter.exclude_selected_symbols === null) {
      filter.exclude_selected_symbols = false
    }
    return api.post<SwapAlertsResponse>(`/v2/alerts/swap`, filter, {
      params: {
        page: page,
        sort_field: sortField,
        sort_order: sortOrder,
      },
    })
  },
  /* dex/cex */
  fetchDex(
    page: number,
    filter: DexAlertsFilter,
    sortField: DexAlertSortingKey,
    sortOrder: SortOrder,
  ) {
    // Устанавливаем стандартное значение
    if (filter.exclude_selected_symbols === null) {
      filter.exclude_selected_symbols = false
    }
    return api.post<DexAlertsResponse>(`/v2/alerts/dex`, filter, {
      params: {
        page: page,
        sort_field: sortField,
        sort_order: sortOrder,
      },
    })
  },
  /* dex/dex */
  fetchDexDex(
    page: number,
    filter: DexDexAlertsFilter,
    sortField: DexDexAlertSortingKey,
    sortOrder: SortOrder,
  ) {
    if (filter.exclude_selected_symbols === null) {
      filter.exclude_selected_symbols = false
    }
    return api.post<DexDexAlertsResponse>(`/v2/alerts/dex-dex`, filter, {
      params: {
        page: page,
        sort_field: sortField,
        sort_order: sortOrder,
      },
    })
  },
  /* dex/dex crosschain */
  fetchDexDexCrosschain(
    page: number,
    filter: DexDexCrosschainAlertsFilter,
    sortField: DexDexCrosschainAlertSortingKey,
    sortOrder: SortOrder,
  ) {
    if (filter.exclude_selected_symbols === null) {
      filter.exclude_selected_symbols = false
    }
    return api.post<DexDexCrosschainAlertsResponse>(`/v2/alerts/dex-dex-crosschain`, filter, {
      params: {
        page: page,
        sort_field: sortField,
        sort_order: sortOrder,
      },
    })
  },
}
